<template>
  <div>
    <van-sticky>
      <van-nav-bar
        title="在线留言"
        left-arrow
        @click-left="$router.go(-1)"
        right-text="发件"
        @click-right="$router.push({path:'sendEmail'})"
      />
    </van-sticky>
    <van-tabs
      v-model="active"
      title-active-color="#3B6BFB"
      title-inactive-color="#666666"
      @click="changeType"
    >
      <van-tab :title="item" v-for="(item,index) in typeArr" :key="index"></van-tab>
    </van-tabs>
	
    <!-- 列表 -->
    <van-list
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      finished-text="没有更多了"
      class="listWrap"
    >
      <div
        class="emailItem"                                                                                                                                                                       
        @click="$router.push({path:'emailDetails',query:{type:active,item:JSON.stringify(item)}})"
        v-for="(item,index) in list"
        :key="index"
      >
        <div class="itemTitle">{{item.title}}</div>
        <div class="itemDesc textEllipsis-2">{{item.content}}</div>
        <div class="itemTime">{{item.create_time}}</div>
      </div>
    </van-list>
  </div>
</template>
<script id="__init-script-inline-widget__">(function(d,t,u,s,e){e=d.getElementsByTagName(t)[0];s=d.createElement(t);s.src=u;s.async=1;e.parentNode.insertBefore(s,e);})(document,'script','//192.168.1.38:10050/omlivechat/php/app.php?widget-init-inline.js');</script>
<script>
import { inboxList, outboxList } from "@/api/personal";
export default {
  data() {
    return {
      active: 0,
      typeArr: ["收件箱", "发件箱"],
      loading: false,
      finished: true,
      form: {
        page: 1,
        pagesize: 10
      },
      list: [],
      count: 0
    };
  },
  created() {
    this.onLoad();
  },
  methods: {
    changeType(e) {
      this.list = [];
      this.form.page = 1;
      if (e == 1) {
        this.onOutLoad();
      } else {
        this.onLoad();
      }
    },
    onLoad() {
      inboxList(this.form).then(resp => {
        this.form.page++;
        let rows = resp.data;
        this.count = resp.count;
        this.loading = false;
        this.finished = false;
        this.list = this.list.concat(rows);
        if (this.list.length >= this.count) {
          this.finished = true;
        }
      });
    },
    onOutLoad() {
      outboxList(this.form).then(resp => {
        this.form.page++;
        let rows = resp.data;
        this.count = resp.count;
        this.loading = false;
        this.finished = false;
        this.list = this.list.concat(rows);
        if (this.list.length >= this.count) {
          this.finished = true;
        }
      });
    }
  }
};
</script>
<style lang='less' scoped>
/deep/ .van-tabs__nav {
  background: #f5f5f5;
}
/deep/ .van-tabs__line {
  background-color: #3B6BFB;
}
/deep/ .van-hairline--top-bottom::after {
  border: 0 none;
}
// 列表
.listWrap {
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;
  .emailItem {
    width: 100%;
    box-sizing: border-box;
    padding: 16px 0 10.5px;
    color: #666666;
    font-size: 12px;
    border-bottom: 1px solid #dedede;
    .itemTitle {
      color: #3e3e3e;
      font-size: 16px;
    }
    .itemDesc {
      margin-top: 10.5px;
    }
    .itemTime {
      text-align: right;
      margin-top: 10.5px;
    }
  }
}
</style>